/**
 * Resolve a `payment_slip` / `payment_proof` value (which may be a base64 data
 * URI from web bookings OR a `/uploads/...` URL path from mobile bookings)
 * into a renderable descriptor.
 *
 * Returns { kind, src, label, filename }:
 *   kind: 'image' | 'pdf' | 'url' | 'other' | 'unknown' | 'none'
 *   src:  the URL or data-URI usable in <img src> / <iframe src> / window.open
 */
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export function resolveProof(raw, bookingId = '') {
  if (!raw) return { kind: 'none', src: null, label: '', filename: '' };
  let kind = 'unknown';
  let src = raw;
  if (raw.startsWith('data:image')) { kind = 'image'; }
  else if (raw.startsWith('data:application/pdf')) { kind = 'pdf'; }
  else if (raw.startsWith('data:')) { kind = 'other'; }
  else if (raw.startsWith('http')) { kind = 'url'; }
  else if (raw.startsWith('/')) { kind = 'url'; src = `${BACKEND_URL}${raw}`; }

  // Guess extension for download filename
  const extByKind = { image: '.jpg', pdf: '.pdf' };
  const isPdfUrl = kind === 'url' && /\.pdf($|\?)/i.test(src);
  const isImgUrl = kind === 'url' && /\.(jpe?g|png|webp|gif|heic|heif)($|\?)/i.test(src);
  const effectiveKind = isPdfUrl ? 'pdf' : isImgUrl ? 'image' : kind;
  const ext = extByKind[effectiveKind] || '';
  const filename = `payment_proof_${(bookingId || '').slice(0, 8) || 'booking'}${ext}`;
  return { kind: effectiveKind, src, filename };
}

/**
 * Pick whichever field is populated — supports legacy and new schemas.
 */
export function pickProof(booking) {
  return booking?.payment_proof || booking?.payment_slip || booking?.payment_proof_url || null;
}
